import { Box, Typography } from "@mui/material";

export const TabPanel = ({children, value, index, ...other}) => {
    return (<div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
    >
    {value === index && (
        <Box sx={{ py: 3 }}>
            <Typography>{children}</Typography>
        </Box>
    )}
    </div>
);
}
  
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}